import { LineChart } from "src/components/chart/line_chart_component";
import { Strings } from "src/constants";
import { IAnalyticData } from "src/features/analytic/data/models/patientAnalytic";
import { AnalyticBody } from "./analyticBody";

export class TotalAnalysisBody extends AnalyticBody {
    title: string = Strings.ANALYSIS_TOTAL_COMPE
}